import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { SideMenuI } from '../../shared/interfaces/side-menu.interface';
import { CUSTOMER_SIDE_MENU_ITEMS } from '../constants/customer-side-menu-items';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-customer-side-menu',
  imports: [RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './customer-side-menu.html',
  styleUrl: './customer-side-menu.scss',
})
export class CustomerSideMenu implements OnInit {
  private readonly router = inject(Router);
  constructor() {}

  customerSideMenuItems = CUSTOMER_SIDE_MENU_ITEMS;
  currentUrl: string = this.router.url.slice(1);
  itemOnHover: string | null = null;
  isSideMenuCollapsed = signal<boolean>(true);

  ngOnInit(): void {}

  itemBeingHovered(item: string | null) {
    this.itemOnHover = item;
  }
  sideMenuItemIcon(state: boolean, item: SideMenuI) {
    return state
      ? item.activeIcon
      : this.itemOnHover === item.route
      ? item.activeIcon
      : item.inactiveIcon;
  }
}
